<script lang="ts">
  import { get } from 'svelte/store'
  import { _ } from 'svelte-i18n'
  import { onMount } from 'svelte'

  const { definition } = $props<{ definition: string }>()

  let container = $state<HTMLElement>(null!)
  let error = $state('')
  let rendered = $state(false)

  onMount(async () => {
    try {
      const isLight = document.documentElement.getAttribute('data-theme') !== 'dark'
      const { default: mermaid } = await import('mermaid')
      mermaid.initialize({
        startOnLoad: false,
        theme: isLight ? 'default' : 'dark',
        themeVariables: isLight ? {
          darkMode: false,
          background: 'transparent',
          primaryColor: '#4d79ff',
          primaryTextColor: '#1a1917',
          primaryBorderColor: '#4a4dd6',
          lineColor: '#9c9a93',
          secondaryColor: '#f4f3ef',
          tertiaryColor: '#eeeee8',
        } : {
          darkMode: true,
          background: 'transparent',
          primaryColor: '#4d79ff',
          primaryTextColor: '#e2e8f0',
          primaryBorderColor: '#4a4dd6',
          lineColor: '#64748b',
          secondaryColor: '#1e293b',
          tertiaryColor: '#0f172a',
        },
        fontFamily: 'inherit',
        securityLevel: 'loose',
      })
      const id = `mermaid-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
      const { svg } = await mermaid.render(id, definition)
      if (container) {
        container.innerHTML = svg
        rendered = true
      }
    } catch (e: any) {
      error = e.message || get(_)('chat.mermaid_block.oshibka_renderinga_diagrammy')
    }
  })
</script>

<div class="my-3 rounded-lg border border-edge overflow-hidden">
  <div class="flex items-center justify-between px-4 py-1.5 bg-code-surface border-b border-edge">
    <span class="text-[10px] uppercase tracking-wider text-muted">mermaid</span>
  </div>
  {#if error}
    <div class="p-4 bg-code-surface">
      <div class="text-xs text-danger mb-2">{$_('chat.mermaid_block.ne_udalos_otrisovat_diagrammu')}</div>
      <pre class="text-xs text-muted whitespace-pre-wrap">{definition}</pre>
    </div>
  {:else}
    <div bind:this={container} class="p-4 bg-code-surface flex justify-center overflow-x-auto [&_svg]:max-w-full"></div>
    {#if !rendered}
      <div class="p-4 bg-code-surface flex justify-center">
        <span class="text-xs text-muted">{$_('chat.mermaid_block.zagruzka_diagrammy')}</span>
      </div>
    {/if}
  {/if}
</div>
